import AppPaths from '@globals/paths'
import { NavHiddenItem } from '../types'

export const tenantNavHiddenConfig: NavHiddenItem[] = [
  {
    path: AppPaths.user.tenants(),
    key: 'userTenants',
    type: 'hiddenNav',
  },
  {
    path: AppPaths.tenant.addDesklessRecoveryMethod(),
    key: 'addDesklessRecoveryMethod',
    type: 'hiddenNav',
  },
  {
    path: AppPaths.tenant.verifyDesklessRecoveryMethod(),
    key: 'verifyDesklessRecoveryMethod',
    type: 'hiddenNav',
  },
  {
    path: AppPaths.tenant.viewCard(':cardId'),
    key: 'viewCard',
    type: 'hiddenNav',
    pathMatch: [/^\/card\//],
  },
  {
    path: AppPaths.tenant.viewCardContributors(':cardId'),
    key: 'viewCardContributors',
    type: 'hiddenNav',
    pathMatch: [/^\/card\//],
  },
]
